import { Check } from 'lucide-react';

import { Spinner } from '../../primitives/Spinner';
import { Field, fieldStyle } from '../venueCreateFields';

import { FormAlert } from './FormAlert';
import { Input } from './Input';
import { FOLLOWING_CHOICES, type FollowingChoice, type SummaryDraft } from './summary-form';
import { SummaryRatingField } from './SummaryRatingField';

interface CoMarketingSummaryFormProps {
  draft: SummaryDraft;
  onChange: (next: SummaryDraft) => void;
  errors: Record<string, string>;
  /** A refusal that is about the whole save rather than one field. */
  message: string | null;
  saving: boolean;
  onSave: () => void;
  onCancel: () => void;
}

/** Edit form for the partner summary, with Save and Cancel. */
export function CoMarketingSummaryForm({
  draft,
  onChange,
  errors,
  message,
  saving,
  onSave,
  onCancel,
}: CoMarketingSummaryFormProps) {
  const hubspotError = errors.hubspotUrl;
  return (
    <div
      style={{
        border: '1px solid var(--nb-border)',
        borderRadius: 10,
        padding: '12px 14px',
        background: 'var(--nb-surface)',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
    >
      <SummaryRatingField
        value={draft.rating}
        onChange={(rating) => onChange({ ...draft, rating })}
        error={errors.comarketingRating}
      />
      <Field label="Following on Instagram">
        <select
          value={draft.following}
          onChange={(e) => onChange({ ...draft, following: e.target.value as FollowingChoice })}
          style={fieldStyle(undefined, { maxWidth: 260 })}
        >
          {FOLLOWING_CHOICES.map((c) => (
            <option key={c.value} value={c.value}>
              {c.label}
            </option>
          ))}
        </select>
      </Field>
      <Field label="HubSpot record URL" error={hubspotError}>
        <Input
          mono
          value={draft.hubspotUrl}
          onChange={(hubspotUrl) => onChange({ ...draft, hubspotUrl })}
          placeholder="https://app.hubspot.com/contacts/company/…"
          error={hubspotError !== undefined}
        />
      </Field>
      {message && <FormAlert message={message} />}
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <button type="button" className="nb-btn nb-btn-ghost" onClick={onCancel} disabled={saving}>
          Cancel
        </button>
        <button
          type="button"
          className="nb-btn nb-btn-primary"
          onClick={onSave}
          disabled={saving}
          style={{ minWidth: 90, justifyContent: 'center' }}
        >
          {saving ? (
            <Spinner size={11} color="currentColor" />
          ) : (
            <Check size={12} aria-hidden="true" />
          )}
          {saving ? 'Saving…' : 'Save'}
        </button>
      </div>
    </div>
  );
}
